import { render, staticRenderFns } from "./CardSimpleWidget.vue?vue&type=template&id=384e783a&scoped=true"
import script from "./CardSimpleWidget.vue?vue&type=script&lang=js"
export * from "./CardSimpleWidget.vue?vue&type=script&lang=js"
import style0 from "./CardSimpleWidget.vue?vue&type=style&index=0&id=384e783a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e783a",
  null
  
)

export default component.exports